import { getNextStageNameFromRoots } from './stageTreeUtils'

export const columnsServices: string[] = [
  'Código da OP',
  'Qtd. Materiais',
  'Materiais',
  'Cliente',
  'Etapa atual',
  'Status',
]

export const columnsServices2: string[] = [
  'OP',
  'Item',
  'Pedido',
  'Peso',
  'Status',
  'Etapa atual',
  'Cliente',
]

export const columnsMachines: string[] = [
  'Máquina',
  'Modelo',
  'Custo/hora',
  'Última manutenção',
  'Próxima manutenção',
  '',
]

export const columnsReports: string[] = [
  'Ordem de serviço',
  'Operador',
  'Máquina',
  'Tempo de produção ',
  'Status',
  '',
]

export const fieldsServices: string[] = [
  'id',
  'quantity',
  'material',
  'destination',
  'status',
]

export const fieldsMachines: string[] = [
  'identification',
  'model',
  'costPerHour',
  'lastMaintenance',
  'nextMaintenance',
]

export const fieldsReports: string[] = [
  'id',
  'producerName',
  'machine',
  'productionPace',
  'status',
]

export const formatStageOperationNumber = (index: number): string =>
  `#${(index + 1) * 10}`

export const formatStageOperationLabel = (stageName: string, index: number): string =>
  `${formatStageOperationNumber(index)} - ${stageName}`

export const getOpStatusText = (status: number): string => {
  switch (status) {
    case 0:
      return 'Em aberto'
    case 1:
      return 'Em produção'
    case 2:
      return 'Concluído'
    default:
      return 'Desconhecido'
  }
}

export const getOpCurrentStageLabel = (serviceStages: any[]): string => {
  if (!serviceStages?.length) return 'Sem estágios'

  const roots = serviceStages.filter((s: any) => s.parentId == null)
  const stageRows = roots.length ? roots : serviceStages
  const allRows = stageRows.flatMap((r: any) => [r, ...(r.Children ?? [])])

  const anyStarted = allRows.some((s: any) => s.startedAt != null)
  if (!anyStarted) return 'Em aberto'

  const hasHierarchy = roots.some(
    (r: any) => (r.Children?.length ?? 0) > 0,
  )
  if (hasHierarchy) {
    return getNextStageNameFromRoots(roots)
  }

  const allCompleted = serviceStages.every((s: any) => s.completed)
  if (allCompleted) return 'Todos concluídos'

  const sorted = [...serviceStages].sort(
    (a, b) => (a.index ?? 0) - (b.index ?? 0),
  )
  const next = sorted.find((s) => !s.completed)
  return next?.Stage?.name || next?.stage?.name || 'Em aberto'
}
